'use strict';

import React from 'react';

class About extends React.Component {
  render() {
    return (
      <div className="about-component" id="empresa">
        <h2 className="title section-title">Detalhe Automóvel</h2>
        <div className="section-content">
        <div className="about">
            <div className="about-title">
              <h2>O que é?</h2>
            </div>
            <p>O <strong>detalhe automóvel / car detail</strong> é o cuidado especializado de qualidade superior e limpeza profunda do automóvel utilizando ferramentas especializadas e produtos premium. O processo envolve a limpeza avançada e o condicionamento do interior e do exterior do automóvel e o objetivo é restaurar a pintura eliminando riscos e manchas de forma a que fique com a aparência de novo, quase como se tivesse saído do stand. Atenção pois não é um serviço de pintura nem reparação de chapa.</p>
            <p>Uma lavagem normal do carro é apenas uma limpeza superficial do automóvel enquanto que o serviço de detalhe automóvel básico é uma lavagem manual e limpeza detalhada onde é usado no exterior um tratamento de argila para limpeza de todas as impurezas e aplicação de cera ou selantes de alta qualidade para uma protecção e brilho da pintura, no interior a limpeza dos tapetes e remoção de nódoas e hidratação de plásticos e ainda a limpeza do motor. Nos serviços mais avançados podemos ter o polimento até 3 fases, o polimento das ópticas, a limpeza profunda das jantes e cavas das rodas, lavagem dos estofos e tratamento e hidratação de peles.</p>
          </div>
          <div className="about">
            <div className="about-title">
              <h2>Quais são as vantagens?</h2>
            </div>
            <p>As vantagens de usar o serviço de detalhe automóvel são evidentes pois a manutenção contínua e pormenorizada do automóvel promove uma proteção adicional contra a exposição aos elementos exteriores, previne contra a contaminação e oxidação da pintura e ainda adiciona valor comercial pois as viaturas em excelentes condições conseguem valor de venda mais elevado.</p>
            </div>
        </div>
      </div>
    );
  }
}

About.displayName = 'About';

// Uncomment properties you need
// Home.propTypes = {};
// Home.defaultProps = {};

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js